import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Smartphone } from "lucide-react";

const EmailVerified = () => {
  const { t } = useTranslation();

  const navigate = useNavigate();

  useEffect(() => {
    // Auto-redirect after 30 seconds
    const timer = setTimeout(() => {
      navigate("/auth");
    }, 30000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center space-y-4">
          <div className="mx-auto w-16 h-16 rounded-full bg-blue-100 dark:bg-blue-900/20 flex items-center justify-center">
            <Smartphone className="w-10 h-10 text-blue-600 dark:text-blue-500" />
          </div>
          <CardTitle className="text-2xl">{t('ui.text.email_verified_successfully')}</CardTitle>
          <CardDescription>{t('ui.text.please_continue_in_the_app_to_complete_your_sign_i')}</CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <Button 
            onClick={() => navigate("/auth")} 
            className="w-full"
            size="lg"
          >{t('ui.text.go_to_sign_in')}</Button>
          <p className="text-sm text-center text-muted-foreground">{t('ui.text.you_will_be_redirected_automatically_in_30_seconds')}</p>
        </CardContent>
      </Card>
    </div>
  );
};

export default EmailVerified;
